import React, { useRef, useState, useCallback } from 'react';
import { connect } from "react-redux";
import EffectComponent from 'components/effects/EffectComponent.js';
import SendComponent from './SendComponent.js';
import {
    setSelectedSendEffect,
} from 'actions/index.js';
import '../../Sends.scss';

function SendsTrackComponent(props) {
    const [sends, setSends] = useState(props.sequencerEngine.sends.sends);
    let ref = useRef(undefined);

    const onDelete = useCallback(() => {
        props.setSelectedSendEffect(undefined);
    }, []);

    let selectedEffect = '';
    if (props.selectedEffect) {
        let send = sends.find(x => x.effects.indexOf(props.selectedEffect) > -1);
        if (!send) {
            let masterChannel = props.sequencerEngine.channelMixer.masterChannel;
            if (masterChannel.effectsChain.effects.includes(props.selectedEffect)) {
                send = masterChannel;
            }
        }
        if (send) {
            selectedEffect = (
                <EffectComponent
                  sequencerEngine={props.sequencerEngine}
                  scrollContainer={[props.scrollContainer, ref]}
                  isDraggable={false}
                  onDeleteEffect={() => onDelete()}
                  effect={props.selectedEffect}
                  send={send}/>);
        }
    }

    const createNewSend = useCallback(() => {
        props.sequencerEngine.sends.createNewSend();
        setSends([... props.sequencerEngine.sends.sends]);
    }, [setSends]);

    return (
        <div ref={ref} className="track sends">
          <div className="track-container">
          <div className="track-header">
            <div className="track-name-view">
              Routing
            </div>
          </div>
          <div className="sends-container">
            {sends
             .filter(send => !send.pad)
             .map((send, i) => <SendComponent key={i} sequencerEngine={props.sequencerEngine} send={send}/>)}
            <SendComponent name="Master" sequencerEngine={props.sequencerEngine}
                           masterChannel={props.sequencerEngine.channelMixer.masterChannel}/>
            {selectedEffect}
            <div
              onClick={createNewSend}
              className="new-send-button">New Send</div>
        </div>
          </div>
        </div>
    );
}
const mapStateToProps = (state, props) => {
    return {
        selectedEffect: state.effects.selectedSendEffect,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setSelectedSendEffect: (e) => dispatch(setSelectedSendEffect(e))
   }
};

export default connect(mapStateToProps, mapDispatchToProps)(SendsTrackComponent);
